/**
 * CommentUpdate
 */

import Config from '../../Config';
import Util from '../../Util';
import Template from '../Template';
import CommentTextCount from './CommentTextCount';

class CommentUpdate {

	public onReply: any;

	public onUploadBefore: any;

	public onSubmit: any;

	private isReply: boolean;

	private _id: string;

	private id: string;

	private articleId: string;

	private commentId: string = '';

	private serviceRef: string = '';

	private currTarget: any;

	private removeCommentId: string;

	private $write: any;

	private $parent: any;

	private formId: string;

	private commentTextCount: CommentTextCount;

	private isSubmit: boolean = false;

	private textArea: string;

	private contentsNode: any;

	private contents: any;

	private lastData: any = {
		contents: '',
	};

	constructor( $parent: any, articleId: string ) {
		this.$parent = $parent;
		this.isReply = false;
		this._id = this.$parent.attr( 'id' );
		this.id = 'contentUpdate';
		this.articleId = articleId || Util.getParams().articleId;
		this.commentId = '';
		this.serviceRef = '';
		this.removeCommentId = '';

		this.onReply = new Util.Observer();
		this.onUploadBefore = new Util.Observer();
		this.onSubmit = new Util.Observer();
		this.onSubmit.add( ( data: any ) => {
			this.result( data );
		});

		this.addSelector();

		this.formId = `comment-form-${this.id}`;
		this.commentTextCount = new CommentTextCount( `#${this._id} .${this.formId}` );
	}

	public addSelector() {
		this.textArea = `#${this._id} .${this.id}`;
	}

	public getNode() {
		return jQuery( this.textArea );
	}

	public appBanned() {
		const url = Config.app.banned( Util.net( '.' ) );
		const _post = Util.get( url, 'GET' );
		_post.then( ( data: any ) => {
			if ( data.is_banned === true ) {
				Config.alert( Config.L10N.alert_banned );
				return;
			}

			this.formCheckAndSubmit();

		}, ( err: any ) => {
			Config.alert( err.message );
		});
	}

	public appLevelBanned() {
		const _lv = Util.getParams().level;
		if ( _lv && _lv < 9 ) {
			Config.alert( Config.L10N.alert_level_check );
			jQuery( this.textArea ).blur();
			return true;
		}
		return false;
	}

	public changeCancelAll() {
		jQuery( `#${this._id} .ncCommentCommonWrap .btn-modify` ).show();
		jQuery( `#${this._id} .ncCommentCommonWrap .btn-delete` ).show();
		jQuery( `#${this._id} .ncCommentCommonWrap .btn-cancel` ).hide();
	}

	public resetHeightSize() {
		jQuery( this.textArea ).css( 'height', '' );
		jQuery( this.textArea ).parent().css( 'height', '' );
	}

	public setPlaceHolder() {
		this.getNode().attr( 'placeholder', ( this.isReply ) ?
			Config.L10N.comment_reply_placeholder_login :
			Config.L10N.comment_placeholder_login_max( Config.commentTextMaxCount ) );
	}

	public setUI() {
		this.$write = jQuery( Template.commentWrite( this.id, Config.L10N.comment_placeholder_login_max( Config.commentTextMaxCount ), true ) );

		jQuery( 'body' ).on( 'focus', this.textArea , ( evt ) => {
			if ( !Config.guid ) {
				jQuery( this.textArea ).blur();
				Config.apiError( {status: 401} );
				return;
			}

			// hover
			jQuery( `#${this._id} .comment-form-${this.id}` ).addClass( 'is-focus' );
		});

		jQuery( 'body' ).on( 'click', `#${this._id} .btn-${this.id}`, ( evt ) => {
			evt.preventDefault();

			if ( Config.isBnsApp ) {
				this.appBanned();
			} else {
				this.formCheckAndSubmit();
			}
		});

		jQuery( 'body' ).on( 'click', `#${this._id} .ncCommentCommonWrap .btn-cancel`, ( evt: any ) => {
			evt.preventDefault();

			const _$this = jQuery( evt.currentTarget );
			this.$parent = _$this.parent().parent();

			this.cancel();

			// hide cancel button;
			this.$parent.find( '.btn-cancel' ).hide();

			// show modify & delete button;
			this.$parent.find( '.btn-modify' ).show();
			this.$parent.find( '.btn-delete' ).show();
		});

		// reply comment Event
		jQuery( 'body' ).on( 'click', `#${this._id} .ncCommentCommonWrap .btn-modify`, ( evt: any ) => {
			evt.preventDefault();
			this.cancel();

			this.changeCancelAll();
			this.resetHeightSize();

			const _$this = jQuery( evt.currentTarget );
			this.$parent = _$this.parent().parent();
			this.commentId = _$this.attr( 'data-commentid' );
			this.serviceRef = _$this.attr( 'data-serviceref' );
			this.contentsNode = this.$parent.find( '.comment-contents' );
			this.contents = this.contentsNode.html().trim();
			this.contents = Util.replaceBr( this.contents );

			this.isReply = this.$parent.hasClass( 'comment-article-reply' );

			// hide modify&delete button;
			this.$parent.find( '.btn-modify' ).hide();
			this.$parent.find( '.btn-delete' ).hide();

			// show cancel button;
			this.$parent.find( '.btn-cancel' ).show();

			// hide contents
			this.contentsNode.hide();

			// show textarea
			const _$writer = this.$write.show();
			this.contentsNode.after( _$writer );
			_$writer.find( `.${this.id}` ).val( this.contents );
			this.commentTextCount.setCountByText( this.contents );
			this.setHeight();

			// set placeHolder
			this.setPlaceHolder();
		});

		// hide cancel button, show modify button
		this.changeCancelAll();
		this.resetHeightSize();

		// return jquery Node
		return this.$write;

	}

	public setHeight() {
		const $_node = this.getNode();

		if ( !this.contentsNode || !$_node.length  ) {
			return;
		}

		const parentRange = 50;
		const fontH = parseInt( this.contentsNode.css('fontSize'), 10 );
		const nodeH = this.contentsNode.height();
		const realNodeH = nodeH + fontH;

		$_node.css( 'height', realNodeH );
		$_node.parent().css('height', realNodeH + parentRange );
	}

	public submit( _data: any, type?: string ) {

		if ( this.isSubmit ) {
			return;
		}

		this.isSubmit = true;

		this.lastData = _data;

		const _method = 'PUT';

		// developer Emoticon
		const commentAPI = Config.commentUpdate({
			board: Config.board,
			articleId: this.articleId,
		});

		const _post = Util.get( commentAPI, _method, this.lastData );
		_post.then( ( data: any ) => {
			data = Util.convertCamelCase( data );

			if ( type ) {
				data.commentResourceType = type;
			}

			this.onSubmit.emit( data );
			this.isSubmit = false;

		}, ( data: any ) => {
			data = Util.convertCamelCase( data );
			this.isSubmit = false;
			Config.apiError( data );
		});
	}

	public cancel() {
		// show and fill new contents
		if ( this.contentsNode ) {
			this.contentsNode.show();
		}

		// hide textarea
		if ( this.$write ) {
			this.$write.hide();
		}
	}

	public formCheckAndSubmit() {
		const _$this: any = jQuery( this.textArea );

		let _val = _$this.val();
		_val = Util.escapeTag( _val );

		if ( _val.length === 0 || !jQuery.trim( _val ) ) {
			Config.alert( ( this.isReply ) ? Config.L10N.alert_empty_reply : Config.L10N.alert_empty_comment );
			return;
		}

		if ( _val.length > Config.commentTextMaxCount ) {
			Config.alert( Config.L10N.comment_placeholder_login_max( Config.commentTextMaxCount ) );
			return;
		}

		_val = _val.replace( /\n/g, '<br />' );

		const _data: any = {
			contents: _val,
			commentId: this.commentId,
			serviceRef: this.serviceRef
		};

		this.submit( _data );
	}

	public result( data: any ) {
		if ( data.comment_id ) {
			data.number = data.comment_id;
		}

		// If data.number is not present, Page should be reloaded;
		if ( !data.contents ) {
			location.reload();
			return;
		}

		// show and fill new contents
		this.contentsNode.show().empty().append( Util.escape( data.contents ) );

		// hide textarea
		this.$write.hide();

		this.changeCancelAll();
		this.resetHeightSize();
	}

	public setCommentId( commentId: string ) {
		this.commentId = commentId;
	}
}

export default CommentUpdate;
